var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Topimage'),_c('Designone'),_vm._l((_vm.menuLists),function(menulist){return _c('Designtwo',{key:menulist.id,ref:`${menulist.id}`,refInFor:true,attrs:{"menulist":menulist}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }